<template>
	<core-button
		:class="classes"
		:disabled="loadingOrDisabled"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<span :style="getStyle"><slot/></span>
		<svg-loading class="loading-button-spinner" v-if="loading"></svg-loading>
	</core-button>
</template>

<script>
export default {
	inheritAttrs : false,
	props        : {
		loading : {
			type    : Boolean,
			default : false,
		},
		disabled : {
			type    : Boolean,
			default : false,
		},
		loadingClass : {
			type    : String,
			default : 'is-loading',
		},
	},
	computed : {
		loadingOrDisabled () {
			return this.loading || this.disabled
		},
		getStyle () {
			return this.loading ? { visibility: 'hidden', height: 0, maxHeight: '0' } : false
		},
		classes () {
			let classes = ''
			classes += ' ' + 'loading-button'
			if (this.loading) {
				classes += ' ' + this.loadingClass
			}

			if ('a' === this.tag) {
				classes += ' button'
			}

			return classes
		},
	},
}
</script>
<style lang="scss" scoped>
	.loading-button {
		display: inline-block;
		position: relative;
		.loading-button-spinner {
			position: absolute;
			width: 20px;
			height: 20px;
			top: calc(50% - 10px);
			left: calc(50% - 10px);
		}
	}
</style>
